import getLocal from '@/app/utils/getLocal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('costsaving');
    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('fix_tab1'), id: '#cost-saving-B', key: 0 },
        { text: t('fix_tab2'), id: '#cost-saving-C', key: 1 },
        { text: t('fix_tab3'), id: '#cost-saving-G', key: 2 },
        { text: t('fix_tab4'), id: '#cost-saving-O', key: 3 },
        // { text: t('fix_tab5'), id: '#cost-saving-P', key: 4 },
        ...(['us', 'ca'].includes(locale) ? [] : [{ text: t('fix_tab6'), id: '#cost-saving-Q', key: 5 }]),
        { text: t('fix_tab7'), id: '#cost-saving-R', key: 6 },
    ];
    // ca去掉Benefits模块
    if (locale === 'ca') tabs.splice(2, 1);
    const handleClickTab = (k: number) => {
        setActiveTab(k);
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeFunc = () => {
                const target = document.querySelector('.cost-saving-fix-tab .tabs-box') as HTMLUListElement;
                target.style.transition = 'left .4s ease';
                if (target.offsetWidth > window.innerWidth && activeTab >= 3) {
                    target.style.left = `${window.innerWidth - target.offsetWidth}px`;
                } else {
                    target.style.left = `${0}px`;
                }
                setTimeout(() => {
                    target.style.transition = 'none';
                }, 400);
            };
            resizeFunc();
            // window.addEventListener('resize', resizeFunc);
            // return () => window.removeEventListener('resize', resizeFunc);
        }
    }, [activeTab]);

    useEffect(() => {
        const scrollFunc = (id: string, k: number) => {
            const target = document.querySelector(id) as HTMLDivElement;
            if (target) {
                AniContainer.create({
                    triggerElement: id,
                    triggerHook: 1,
                    offset: '50%',
                    duration: target?.offsetHeight,
                    onEnter: () => setActiveTab(k),
                });
            }
        };

        const ids: string[] = ['#cost-saving-B', '#cost-saving-C', '#cost-saving-G', '#cost-saving-O', '#cost-saving-Q', '#cost-saving-R'];
        ids.forEach((id: string, k: number) => scrollFunc(id, k));

        // AniContainer.create({
        //     triggerElement: '#cost-saving-R',
        //     triggerHook: 1,
        //     offset: '50%',
        //     onEnter: () => setActiveTab(5),
        // });

        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            }
        }, 3000);
    }, []);

    return (
        <div className={`cost-saving-fix-tab ${css['cost-saving-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
